import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Contato.module.css';

export default function Contato() {
    const navigate = useNavigate();
    const nome = sessionStorage.getItem('nomeUsuario') || '';
    const primeiroNomeRaw = nome.split(' ')[0] || '';
    const primeiroNome = primeiroNomeRaw
        ? primeiroNomeRaw.charAt(0).toUpperCase() + primeiroNomeRaw.slice(1).toLowerCase()
        : '';

    return (
        <div className={styles.wrap}>

            <div className={styles.iconWrap}>
                <span className={styles.icon}>⚠️</span>
            </div>

            <h1 className={styles.title}>
                {primeiroNome
                    ? <><strong className={styles.name}>{primeiroNome}</strong>, infelizmente, </>
                    : 'Infelizmente, '}
                a Crefaz não possui uma oferta disponível para você no momento.
            </h1>

            <p className={styles.message}>
                A aprovação está sujeita à análise de crédito e aos critérios do produto,
                como titularidade da conta de energia, fornecimento ativo e dados
                cadastrais válidos.
            </p>

            <p className={styles.message}>
                Se você acredita que atende aos requisitos, entre em contato com a
                Crefaz para mais informações:
            </p>

            <p className={styles.phone}>
                <span className={styles.phoneIcon}>📞</span> 0800 052 5051
            </p>

        </div>
    );
}